module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Article/Thumbnails/Text-b58f944d11d15315617362c9fcbdcb46.png";